import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionIcon, Group, Text } from '@mantine/core';
import { IconWorld } from '@tabler/icons-react';

interface LanguageSwitcherProps {
  /** В свёрнутом меню всё стоит в одну колонку — глобус с подписью рядом ломал бы ряд. */
  compact?: boolean;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ compact = false }) => {
  const { i18n, t } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ru' ? 'en' : 'ru';
    i18n.changeLanguage(newLang);
  };

  const title =
    i18n.language === 'ru' ? t('language.switchToEnglish') : t('language.switchToRussian');
  const code = i18n.language.toUpperCase();

  // Свёрнуто — только код языка: он и говорит, какой язык сейчас включён,
  // а глобус без подписи этого не сообщает.
  if (compact) {
    return (
      <ActionIcon
        variant="outline"
        size="sm"
        onClick={toggleLanguage}
        title={title}
        aria-label={title}
      >
        <Text size="9px" fw={700}>
          {code}
        </Text>
      </ActionIcon>
    );
  }

  return (
    <Group gap={8} align="center">
      <ActionIcon
        variant="outline"
        size="sm"
        onClick={toggleLanguage}
        title={title}
        aria-label={title}
      >
        <IconWorld size={12} />
      </ActionIcon>
      <Text size="xs" c="dimmed">
        {code}
      </Text>
    </Group>
  );
};
